(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    /**
     * Enables open/close and active filter-item functionality for "filter" taxonomy.
     */
    (function(){
        var containerSelector = '.filter-nav';
        if (!document.querySelector(containerSelector)) return;

        function writeCookie(name, value, seconds, raw) {
            var expires = "";
            if (seconds) {
                var date = new Date();
                date.setTime(date.getTime() + (seconds * 1000));
                expires = "; expires=" + date.toGMTString();
            }
            document.cookie = name + "=" + value + expires + "; path=/" + raw;
        }

        function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        }

        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }

        function notEqualTo(value) {
            return (function(v){ return v !== value; });
        }

        function getOpened() {
            var value = readCookie('openFilters3');
            if ( ! value) value = [];
            else value = value.split(',');
            return value;
        }

        function setOpened(value) {
            value.filter(function (item) {
                //return ! isNaN(parseInt(item));
            } );
            writeCookie('openFilters3', value.join(','), null, '; SameSite=Strict');
        }

        document.body.addEventListener('click', function(e){
            if (!e.target.matches('.filter-nav__group-title') && !e.target.matches('.filter-nav__show-link')) return;
            e.preventDefault();
            var itemElem = e.target.closest('.filter-nav__group');
            var groupId = itemElem.getAttribute('data-group-id');
            itemElem.classList.toggle('on');

            // remember state
            var openFilters = getOpened();
            if (itemElem.classList.contains('on')) openFilters.push(groupId);
            else openFilters = openFilters.filter(notEqualTo(groupId));
            openFilters = openFilters.filter(onlyUnique);
            setOpened(openFilters);
        }, false);

        // open by id
        var i, elem, ids = getOpened();
        for (i = 0; i < ids.length; i++) {
            elem = document.getElementById('filter-nav__group--' + ids[i]);
            if (elem) elem.classList.add('on');
        }

        // force open if child items are selected/checked
        var items = document.querySelectorAll('.filter-nav__item.active');
        for (i = 0; i < items.length; i++) {
            items[i].closest('.filter-nav__group').classList.add('on');
        }

        // remove expand/collase link if preview threshold >= submenu children count
        var groups = document.querySelectorAll('.filter-nav__group');
        groups.forEach(function(group){
            var childrenCount = group.querySelector('.filter-nav__submenu').children.length;
            var previewCount = group.getAttribute('data-preview-count');
            if (previewCount >= childrenCount) group.classList.add('no-expand');
        });

        var dataBucket = {};
        var bucketCounter = 0;
        function setElementData(elem, name, value) {
            var bucketId = elem.getAttribute('data-bucket-id');
            if (null === bucketId) {
                bucketId = ++bucketCounter;
                elem.setAttribute('data-bucket-id', bucketId);
                dataBucket[bucketId] = {};
            }
            if (undefined === name) return false;
            dataBucket[bucketId][name] = value;
            return dataBucket[bucketId][name];
        }
        function getElementData(elem, name, defaultValue) {
            if (undefined === name) return undefined;
            var bucketId = elem.getAttribute('data-bucket-id');
            if (null === bucketId) return defaultValue;
            if (undefined === dataBucket[bucketId][name]) return defaultValue;
            return dataBucket[bucketId][name];
        }

        /*
        // clear terms/filters link
        document.body.addEventListener('click', function(e){
            if (!e.target.matches('.filter-nav__clear-link')) return;
            var targetSelector = e.target.getAttribute('data-target-selector');
            var filterNavElem = targetSelector ? document.querySelector(targetSelector) : e.target.closest('.filter-nav');
            if (!filterNavElem) return;
            e.preventDefault();
            var items = filterNavElem.querySelectorAll('.filter-nav__item.active');
            if (!items.length) return;
            items.forEach(function(elem){
                elem.classList.remove('active');
            });
            //delete dataBucket[getBucketId(filterNavElem)];
            setElementData(filterNavElem, 'termIds', {});
            setElementData(filterNavElem, 'termSlugs', {});
            // dispatch CustomEvent "filterChange"
            filterNavElem.dispatchEvent(new CustomEvent('filterChange', {
                bubbles: true,
                cancelable: true,
                detail: {
                    terms: [],
                    termSlugs: []
                }
            }));
        }, false);
        */

        // term link
        document.body.addEventListener('click', function(e){
            if (!e.target.matches('.filter-nav__item-link')) return;
            var filterNavElem = e.target.closest('.filter-nav');
            if (!filterNavElem) return;
            if (-1 == filterNavElem.className.indexOf('js-behavior')) return;
            e.preventDefault();

            var itemElem = e.target.closest('.filter-nav__item');
            var radioParentItem = itemElem.closest('.radio');
            var termId = itemElem.getAttribute('data-term-id');
            var termSlug = itemElem.getAttribute('data-term-slug');

            var termIds = getElementData(filterNavElem, 'termIds', {});
            var termSlugs = getElementData(filterNavElem, 'termSlugs', {});

            // check for radio type parent item, clear children
            if (radioParentItem) {
                radioParentItem.querySelectorAll('.children > .filter-nav__item').forEach(function(elem){
                    // current item handled below
                    if (itemElem == elem) return;
                    delete termIds[elem.getAttribute('data-term-id')];
                    delete termSlugs[elem.getAttribute('data-term-slug')];
                    elem.classList.remove('active');
                });
            }
            // remove termId if present else add termId
            if (termIds.hasOwnProperty(termId)) {
                delete termIds[termId];
                delete termSlugs[termSlug];
                itemElem.classList.remove('active');
            } else {
                termIds[termId] = true;
                termSlugs[termSlug] = true;
                itemElem.classList.add('active');
            }

            setElementData(filterNavElem, 'termIds', termIds);
            setElementData(filterNavElem, 'termSlugs', termSlugs);

            // dispatch CustomEvent "filterChange"
            filterNavElem.dispatchEvent(new CustomEvent('filterChange', {
                bubbles: true,
                cancelable: true,
                detail: {
                    terms: Object.keys(termIds).sort(),
                    termSlugs: Object.keys(termSlugs).sort()
                }
            }));
        }, false);
        // toggle link
        document.body.addEventListener('click', function(e){
            if (!e.target.matches('.filter-nav__toggle-link')) return;
            e.preventDefault();
            e.target.closest('.filter-nav').classList.toggle('on');
        }, false);
    })();

}));
